/**
 * Created by Mark on 22/11/2016.
 */

import { Dispatcher } from 'flux';

export default new Dispatcher();